import React from 'react'
import Translation from '../global/Translation'

import { injectIntl } from 'react-intl'
import Alerts from '../alerts/Alerts'
import DisplayPrice from "../catalog/rectangleResult/displays/DisplayPrice";
import {getProfileConfiguration} from "../../store/profile-configuration/reducers";
import {connect} from "react-redux";
import {
    getIsMkToolsCenter
} from "../../store/centers/reducers";
import { getPriceListAtSelectedCenter, getUserPriceList } from '../../store/login/reducers'
import ProductDisplayName from "../global/ProductDisplayName";


const mapStateToProps = state => {
    return {
        userPreferences: getProfileConfiguration(state),
        priceList: getPriceListAtSelectedCenter(state),
        userPriceList: getUserPriceList(state),
        isMktoolsCenter: getIsMkToolsCenter(state),
    }
}


class LotsHeader extends React.Component {

    state={
        showAdvisorAlert: true
    }

    render() {
        const { original, filtered, goBack, intl } = this.props

        const lotsBooked = filtered ? (
            <div className="row mt-2">
                <div className="col-12">
                    <Alerts alert={'LOTS_ALREADY_BOOKED'} status="warning" />
                </div>
            </div>
        ) : null

        return (
            <div>
                <div className="toolbar">
                    <div className="row align-items-end no-gutters">
                        <div className="col-12 mb-1">
                            <div className="position-relative position-lg-absolute mb-lg-0"
                                 style={{position:"absolute", top:0, left:0, fontSize:"14px", color:"#232323", fontWeight:"500"}}>
                                <div className="go-back" onClick={goBack}>
                                    <span>
                                        <i className="fal fa-chevron-left" />&nbsp;
                                        <Translation id="back_to" defaultMessage="Back to" />&nbsp;
                                        <ProductDisplayName product={original} />
                                    </span>
                                </div>
                            </div>

                            {original && (
                                <div className="lots__header__container">
                                    <div className="lots__header__container--title">
                                        <span><Translation id="choose_lots_of" defaultMessage="Choose lots of" />&nbsp;</span>
                                        <ProductDisplayName product={original} />&nbsp;
                                        {original.thickness.toLowerCase()} cm,&nbsp;
                                        {intl.formatMessage({ id: original.finish }).toLowerCase()}.
                                    </div>

                                    <div className="lots__header__container--price">
                                        <DisplayPrice
                                            userPreferences={this.props.userPreferences}
                                            priceList={this.props.priceList}
                                            userPriceList={this.props.userPriceList}
                                            product={original}
                                            isMktoolsCenter={this.props.isMktoolsCenter}
                                            centerId={this.props.centerId}
                                        />
                                    </div>

                                    <div className="lots__header__container--text">
                                        <Translation id="lots-faster-way-message" defaultMessage="Now you can select loose boards, complete or partial bundles in a faster way"/>
                                    </div>
                                </div>
                            )}
                        </div>

                    </div>
                    {lotsBooked}
                </div>

            </div>
        )
    }
}

export default injectIntl(
    connect(
        mapStateToProps,
        null
    )(LotsHeader)
)

